site.window = {
	scrollPosition: 0
};

site.magnific = {
	// Webcam image source
	webcamSrc: $('a.camera', "#qn").attr('href'),
	webcamReloadInterval: null,

	init: function () {
		// Initialize extras item gallery
		$('.magnific-item').magnificPopup({
			type: 'iframe',
			gallery: {
				enabled: true
			}
		});
	}
};

site.inits.push('site.magnific.init()');
